import { useEffect, useState } from 'react';

import { useMutationObserver } from '@hooks/useMutationObserver';

type Hook = (fullScreenPortalId: string) => HTMLElement | null;

export const useWaitForPortalTarget: Hook = (fullScreenPortalId) => {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const initialTarget = document.getElementById(fullScreenPortalId);

    if (initialTarget) {
      setPortalTarget(initialTarget);
    }
  }, [fullScreenPortalId]);

  useMutationObserver(
    document.body,
    () => {
      const target = document.getElementById(fullScreenPortalId);

      if (target) {
        setPortalTarget(target);
      }
    },
    { childList: true, subtree: true }
  );

  return portalTarget;
};
